var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconAddStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    stroke: "#E5E7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2754 6.25C15.2854 6.25019 16.1124 7.00399 16.1826 7.95898L16.1875 8.09082V8.70508H18.7373C19.0894 8.70508 19.375 8.97946 19.375 9.31836C19.375 9.62896 19.1353 9.88606 18.8242 9.92676L18.7373 9.93164H18.1006V17.9092C18.1006 18.8816 17.3166 19.6776 16.3242 19.7451L16.1875 19.75H9.8125C8.80247 19.7498 7.97545 18.9961 7.90527 18.041L7.90039 17.9092V9.93164H7.2627C6.91062 9.93164 6.62501 9.65726 6.625 9.31836C6.625 9.00775 6.8647 8.75066 7.17578 8.70996L7.2627 8.70508H9.8125V8.09082C9.81255 7.11836 10.5964 6.32229 11.5889 6.25488L11.7256 6.25H14.2754ZM9.17578 9.93164V17.9092C9.17578 18.2198 9.4154 18.4769 9.72656 18.5176L9.8125 18.5225H16.1875C16.5101 18.5223 16.7771 18.2916 16.8193 17.9922L16.8252 17.9092V9.93164H9.17578ZM11.7256 7.47754C11.4029 7.47754 11.136 7.70831 11.0938 8.00781L11.0879 8.09082V8.70508H14.9131V8.09082C14.913 7.78028 14.6723 7.52315 14.3613 7.48242L14.2754 7.47754H11.7256Z",
    fill: "#EE4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconAddStaff);
export default __webpack_public_path__ + "static/media/delete_icon_add_staff.f966bc70306a87b2547f41efa3409394.svg";
export { ForwardRef as ReactComponent };